<template>
    <loading v-if="isLoading"></loading>
    <div v-else>

        <p>Standaard zijn alle onderstaande opdrachten beschikbaar voor de leerlingen.
        U kunt tijd vrij maken voor eigen opdrachten door opdrachten hieronder uit te schakelen. Dit kan ook later aangepast worden.</p>

        <div v-for="term in terms" class="assignment-toggle__term">

            <hr>
            <h2 class="assignment-toggle__term-title">{{ term.title }}</h2>

            <div v-for="period in term.periods" class="assignment-toggle__period">

                <p class="assignment-toggle__period-title tag" :class="{ 'assignment-toggle__period-title--error': hasError(period) }">{{ period.title }}</p>

                <div v-for="assignment in period.assignments" class="assignment-toggle" :class="{ 'is-disabled': isOptional(assignment) }" >
                    <a href="#" @click.prevent="toggleAssignment(assignment)" class="assignment-toggle__link">
                        <img :src="assignment.image" :alt="assignment.title" class="assignment-toggle__hero" />
                        <span class="assignment-icon" :class="'icon-' + assignment.type"></span>
                        <h3 class="assignment-toggle__title">{{ assignment.title }}</h3>
                        <p class="assignment-toggle__subtitle">{{ assignment.subtitle }}</p>
                        <span class="time tag tag--timid">{{ assignment.time }} minuten</span>
                    </a>
                </div>
            </div>

        </div>

        <primary-button @clicked="save" :loading="isSaving" v-transfer-dom="'modal__footer'">{{ isCreating ? 'Volgende' : 'Opslaan' }}</primary-button>

    </div>
</template>


<script>
import notify from 'js/components/notifications/notificationsMixin'
import validation from 'js/components/auth/validationMixin'

import PrimaryButton from 'js/components/elements/PrimaryButton.vue'
import Loading from 'js/components/elements/Loading.vue'

import api from 'js/api/resources'
import track from 'js/helpers/analytics'
import { transform } from 'js/vuex/helpers'

export default {
    name: 'GroupSettingsAssignments',
    mixins: [ notify, validation, ],
    components: { PrimaryButton, Loading },
    props: {
        group: {},
        school: {},
        isCreating: {
            type: Boolean,
            default: false
        },
        isDemo: {
            type: Boolean,
            default: false
        },
    },

    data: function() {
        return {
            isSaving: false,
            isLoading: true,

            terms: [],
            groupAssignments: [],
        }
    },

    vuex: {
        actions: {
            setOptional: ({dispatch}, groupId, data) => {
                return api.patchAssignmentsForGroup(groupId, data)
                    .then( response => transform(response.body) )
                    .then( result => {
                        const ga = result.groupassignments || []
                        dispatch('ADD_GROUP_ASSIGNMENTS', ga)
                        return ga
                    })
            }
        }
    },

    computed: {

        optionalAssignments: function() {
            return this.groupAssignments.filter( ga => ga.optional ).map( ga => ga.assignment[0] )
        },

    },

    methods: {

        submit: function(e) {
            e.preventDefault()
            this.save().catch(() => {})
        },

        save: function() {

            if ( this.isDemo ) {
                this.$demoSuccessNotification()
                this.$emit('saved')
                return Promise.resolve()
            }

            this.isSaving = true

            const optionalAssignments = this.groupAssignments.filter(ga => ga.optional).map(ga => ga.id)
            const p = this.setOptional(this.group.id, optionalAssignments)
                .then( () => {
                    this.$emit('saved')
                    this.$success( this.isCreating ? 'De klas is aangemaakt' : 'De opdrachten zijn aangepast')
                })
                .catch( err => {
                    track.exception('Can\'t update assignments', err)
                    this.$error('Aanpassen opdrachten mislukt')
                    return Promise.reject(err)
                })

            // finally
            p.catch( () => {} ).then( () => this.isSaving = false )
            return p

        },

        isOptional: function(assignment) {
            return this.optionalAssignments.indexOf( assignment.id ) !== -1
        },

        toggleAssignment: function(assignment) {
            let groupAssignment = this.groupAssignments.find( ga => ga.assignment[0] == assignment.id)
            groupAssignment.optional = !groupAssignment.optional
            this.$emit('changed')
        },

        hasError: function(period) {
            return period.assignments.filter( a => this.optionalAssignments.indexOf(a.id) === -1 ).length === 0
        },

        fetchPlanning: function(groupId) {
            return api.getPlanning( groupId )
                .then( response => transform(response.body) )
                .then( result => {
                    this.groupAssignments = result.groupassignments

                    // hydrated planning
                    // term.periods.assignments
                    this.terms = result.groupterms.map( gt => {
                        let term = result.terms.find(t => t.id == gt.term[0])
                        term.periods = gt.groupPeriods.map ( id => {
                            let gp = result.groupperiods.find(gp => gp.id == id)
                            let period = result.periods.find(p => p.id == gp.period[0] )
                            period.assignments = gp.groupAssignments.map( id => {
                                let ga = result.groupassignments.find( ga => ga.id == id)
                                return result.assignments.find( a => a.id == ga.assignment[0] )
                            })
                            return period
                        })
                        return term

                    })
                })
                .catch( err => {
                    track.exception('Can\'t load assignments', err)
                    this.$error('Kan opdrachten niet laden')
                })
        },

    },


    created: function() {

        this.fetchPlanning(this.group.id)
            .then( () => this.isLoading = false )

    }

}
</script>


<style lang="scss">

    @import 'global';
    $assignment-icon-border-size: 3px;
    $assignment-icon-size: 52px;

    .assignment-toggle {

        width: 150px;
        padding: 0;
        margin: 20px 30px;
        display: inline-block;

        text-align: center;
        vertical-align: top;

        position: relative;

        &:after {
            // hover message
            position: absolute;
            pointer-events: none;
            top: 80px;
            width: 100%;
            display: block;
            left: 0;
            color: white;
            border-radius: 4px;
            z-index: 2;
        }

        &:hover:after {
          content: "Uitschakelen";
          background-color: $color-grey;
        }

        &.is-disabled {

            &:after, &:hover:after {
              content: "Uitgeschakeld";
              background-color: $color-warning;
            }

            .assignment-toggle__link {
                opacity: 0.5;
                color: $color-grey;
            }
        }

        &__term-title {
            text-align: center;
            margin-bottom: -60px;
        }

        &__period {
            margin: 100px -60px;
            padding: 0;
            text-align: center;
        }

        &__link {
            display: block;
            text-decoration: none;
            position: relative;
            color: $color-typography;
        }

        &__hero {
            width: 150px !important;
            height: 150px;
            border: none;
            border-radius: 50%;
            margin: 0 auto;
            display: inline-block !important;
        }

        &__period-title {
            margin-bottom: 0;

            &--error {
                color: $color-warning;
            }
        }

        &__title {
            margin: 0.6em 0 0.2em;
        }

        &__subtitle {
            margin: 0.2em 0;
        }

        .assignment-icon {
            position: absolute;
            top: 133px;
            left: 50%;
            margin-left: -($assignment-icon-size+$assignment-icon-border-size)/2;
        }

    }

</style>



// WEBPACK FOOTER //
// Assignments.vue?4ae66f4c